import { createBrowserRouter, Navigate } from "react-router-dom";
import InterviewScheduleForm from "./pages/InterviewScheduleForm";
import InterviewVideoCallPage from "./pages/InterviewScheduleForm/InterviewVideoCallPage";
import CandidateDashboard from "./pages/CandidateDashboard";
import UploadForm from "./pages/InterviewScheduleForm/UploadForm";
import SetUpInterview from "./pages/InterviewScheduleForm/setUpInterview";
import LoginForm from "./pages/Login";
import SignUp from "./pages/SignUp/SignUp";
import Layout from "./layout";
import SetUpMCQ from "./pages/InterviewScheduleForm/setUpMCQ";
import McqInterview from "./pages/InterviewScheduleForm/InterviewVideoCallPage/McqInterview";
import CodingInterview from "./pages/InterviewScheduleForm/InterviewVideoCallPage/CodingInterview";
import SetUpCoding from "./pages/InterviewScheduleForm/setUpCoding";
import CandidateJobsStatus from "./pages/InterviewScheduleForm/CandidateJobsStatus";
import CreatedJobs from "../src/pages/InterviewScheduleForm/CreatedJobs";
import HRDashboardPage from "./pages/InterviewScheduleForm/HrDashboard";

// const isLoggedIn = () => {
//   let loggedIn = localStorage?.getItem("access_token");
//   if (!loggedIn) {
//     window.location.replace("http://localhost:3000/login");
//   }
// };

const isLoggedIn = () => {
  const loggedIn = localStorage?.getItem("access_token");
  if (!loggedIn) {
    const baseUrl = window.location.origin;
    window.location.replace(`${baseUrl}/login`);
  }
};


// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Layout />,
//     children: [
//       {
//         path: "/create-position",
//         element: <InterviewScheduleForm />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/ai-interview",
//         element: <InterviewVideoCallPage />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/candidate-dashboard",
//         element: <CandidateDashboard />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/compare-resume",
//         element: <UploadForm />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/setup-interview",
//         element: <SetUpInterview />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/setup-mcq",
//         element: <SetUpMCQ />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/mcq-interview",
//         element: <McqInterview />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/setup-coding",
//         element: <SetUpCoding />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/coding-interview",
//         element: <CodingInterview />,
//         loader: isLoggedIn,
//       },
//       {
//         path: "/sign-up",
//         element: <SignUp />,
//       },
//     ],
//   },
//   {
//     path: "/login",
//     element: <LoginForm />,
//   },
// ]);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/login" replace />, // default route redirects to login
  },
  {
    path: "/login",
    element: <LoginForm />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/create-position",
        element: <InterviewScheduleForm />,
        loader: isLoggedIn,
      },
      {
        path: "/ai-interview",
        element: <InterviewVideoCallPage />,
        loader: isLoggedIn,
      },
      {
        path: "/candidate-dashboard",
        element: <CandidateDashboard />,
        loader: isLoggedIn,
      },
      {
        path: "/compare-resume",
        element: <UploadForm />,
        loader: isLoggedIn,
      },
      {
        path: "/candidate-jobs",
        element: <CandidateJobsStatus />,
        loader: isLoggedIn,
      },
      {
        path: "/created-jobs",
        element: <CreatedJobs />,
        loader: isLoggedIn,
      },
      {
        path: "/setup-interview",
        element: <SetUpInterview />,
        loader: isLoggedIn,
      },
      {
        path: "/setup-mcq",
        element: <SetUpMCQ />,
        loader: isLoggedIn,
      },
      {
        path: "/mcq-interview",
        element: <McqInterview />,
        loader: isLoggedIn,
      },
      {
        path: "/setup-coding",
        element: <SetUpCoding />,
        loader: isLoggedIn,
      },
      {
        path: "/coding-interview",
        element: <CodingInterview />,
        loader: isLoggedIn,
      },
      {
        path: "/sign-up",
        element: <SignUp />,
      },
      {
        path:"/hr-dashboard",
        element:<HRDashboardPage/>
      }
    ],
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />, // handle unknown routes
  },
]);

export default router;
